

function NoNotes() {

    return (
        <div id="no-note-text">Select a note, or create a new one.</div>
    );
}

export default NoNotes